import {Col, Container, Row} from "react-bootstrap";
import React from "react";
export default function RejectButton(props) {
    return (<>
        <Container fluid className={props.isActionColBtn?"d-none":"m-0 p-0"}>
            <a href="#" onClick={props.onRejectButtonClick}>
                <span className='d-md-block'>{props.buttonTitle}</span>
            </a>
        </Container>
        <Container fluid className={!props.isActionColBtn?"d-none":"m-0 p-0"}>
            <button className="btn btn-block td-btn-secondary-clear my-3" href="#" onClick={props.onRejectButtonClick}>
                {props.buttonTitle??'Reject'}
            </button>
        </Container>
    </>)
}